// GENERATO da scripts/build-redirects.mjs — non modificare a mano.
// 1118 percorsi legacy. Il 301 REALE avviene in Nginx
// (docker/nginx/redirects.map); questa mappa è la rete di sicurezza
// client-side per link interni vecchi, bookmark e cronologia.

export const LEGACY_REDIRECTS: Readonly<Record<string, string>> = {
  '/comuni/accadia.html': '/comuni/accadia/',
  '/comuni/acquarica_del_capo.html': '/comuni/acquarica_del_capo/',
  '/comuni/acquaviva_delle_fonti.html': '/comuni/acquaviva_delle_fonti/',
  '/comuni/adelfia.html': '/comuni/adelfia/',
  '/comuni/alberobello.html': '/comuni/alberobello/',
  '/comuni/alberona.html': '/comuni/alberona/',
  '/comuni/alessano.html': '/comuni/alessano/',
  '/comuni/alezio.html': '/comuni/alezio/',
  '/comuni/alliste.html': '/comuni/alliste/',
  '/comuni/altamura.html': '/comuni/altamura/',
  '/comuni/andrano.html': '/comuni/andrano/',
  '/comuni/andria.html': '/comuni/andria/',
  '/comuni/anzano_di_puglia.html': '/comuni/anzano_di_puglia/',
  '/comuni/apricena.html': '/comuni/apricena/',
  '/comuni/aradeo.html': '/comuni/aradeo/',
  '/comuni/arnesano.html': '/comuni/arnesano/',
  '/comuni/ascoli_satriano.html': '/comuni/ascoli_satriano/',
  '/comuni/avetrana.html': '/comuni/avetrana/',
  '/comuni/bagnolo_del_salento.html': '/comuni/bagnolo_del_salento/',
  '/comuni/bari.html': '/comuni/bari/',
  '/comuni/barletta.html': '/comuni/barletta/',
  '/comuni/biccari.html': '/comuni/biccari/',
  '/comuni/binetto.html': '/comuni/binetto/',
  '/comuni/bisceglie.html': '/comuni/bisceglie/',
  '/comuni/bitetto.html': '/comuni/bitetto/',
  '/comuni/bitonto.html': '/comuni/bitonto/',
  '/comuni/bitritto.html': '/comuni/bitritto/',
  '/comuni/botrugno.html': '/comuni/botrugno/',
  '/comuni/bovino.html': '/comuni/bovino/',
  '/comuni/brindisi.html': '/comuni/brindisi/',
  '/comuni/cagnano_varano.html': '/comuni/cagnano_varano/',
  '/comuni/calimera.html': '/comuni/calimera/',
  '/comuni/campi_salentina.html': '/comuni/campi_salentina/',
  '/comuni/candela.html': '/comuni/candela/',
  '/comuni/cannole.html': '/comuni/cannole/',
  '/comuni/canosa_di_puglia.html': '/comuni/canosa_di_puglia/',
  '/comuni/caprarica_di_lecce.html': '/comuni/caprarica_di_lecce/',
  '/comuni/capurso.html': '/comuni/capurso/',
  '/comuni/carapelle.html': '/comuni/carapelle/',
  '/comuni/carlantino.html': '/comuni/carlantino/',
  '/comuni/carmiano.html': '/comuni/carmiano/',
  '/comuni/carosino.html': '/comuni/carosino/',
  '/comuni/carovigno.html': '/comuni/carovigno/',
  '/comuni/carpignano_salentino.html': '/comuni/carpignano_salentino/',
  '/comuni/carpino.html': '/comuni/carpino/',
  '/comuni/casalnuovo_monterotaro.html': '/comuni/casalnuovo_monterotaro/',
  '/comuni/casalvecchio_di_puglia.html': '/comuni/casalvecchio_di_puglia/',
  '/comuni/casamassima.html': '/comuni/casamassima/',
  '/comuni/casarano.html': '/comuni/casarano/',
  '/comuni/cassano_delle_murge.html': '/comuni/cassano_delle_murge/',
  '/comuni/castellana_grotte.html': '/comuni/castellana_grotte/',
  '/comuni/castellaneta.html': '/comuni/castellaneta/',
  '/comuni/castelluccio_dei_sauri.html': '/comuni/castelluccio_dei_sauri/',
  '/comuni/castelluccio_valmaggiore.html': '/comuni/castelluccio_valmaggiore/',
  '/comuni/castelnuovo_della_daunia.html': '/comuni/castelnuovo_della_daunia/',
  '/comuni/castri_di_lecce.html': '/comuni/castri_di_lecce/',
  '/comuni/castrignano_de_greci.html': '/comuni/castrignano_de_greci/',
  '/comuni/castrignano_del_capo.html': '/comuni/castrignano_del_capo/',
  '/comuni/castro.html': '/comuni/castro/',
  '/comuni/cavallino.html': '/comuni/cavallino/',
  '/comuni/ceglie_messapica.html': '/comuni/ceglie_messapica/',
  '/comuni/celenza_valfortore.html': '/comuni/celenza_valfortore/',
  '/comuni/cellamare.html': '/comuni/cellamare/',
  '/comuni/celle_di_san_vito.html': '/comuni/celle_di_san_vito/',
  '/comuni/cellino_san_marco.html': '/comuni/cellino_san_marco/',
  '/comuni/cerignola.html': '/comuni/cerignola/',
  '/comuni/chieuti.html': '/comuni/chieuti/',
  '/comuni/cisternino.html': '/comuni/cisternino/',
  '/comuni/collepasso.html': '/comuni/collepasso/',
  '/comuni/conversano.html': '/comuni/conversano/',
  '/comuni/copertino.html': '/comuni/copertino/',
  '/comuni/corato.html': '/comuni/corato/',
  '/comuni/corigliano_dotranto.html': '/comuni/corigliano_dotranto/',
  '/comuni/corsano.html': '/comuni/corsano/',
  '/comuni/crispiano.html': '/comuni/crispiano/',
  '/comuni/cursi.html': '/comuni/cursi/',
  '/comuni/cutrofiano.html': '/comuni/cutrofiano/',
  '/comuni/deliceto.html': '/comuni/deliceto/',
  '/comuni/diso.html': '/comuni/diso/',
  '/comuni/erchie.html': '/comuni/erchie/',
  '/comuni/faeto.html': '/comuni/faeto/',
  '/comuni/faggiano.html': '/comuni/faggiano/',
  '/comuni/fasano.html': '/comuni/fasano/',
  '/comuni/foggia.html': '/comuni/foggia/',
  '/comuni/fragagnano.html': '/comuni/fragagnano/',
  '/comuni/francavilla_fontana.html': '/comuni/francavilla_fontana/',
  '/comuni/gagliano_del_capo.html': '/comuni/gagliano_del_capo/',
  '/comuni/galatina.html': '/comuni/galatina/',
  '/comuni/galatone.html': '/comuni/galatone/',
  '/comuni/gallipoli.html': '/comuni/gallipoli/',
  '/comuni/ginosa.html': '/comuni/ginosa/',
  '/comuni/gioia_del_colle.html': '/comuni/gioia_del_colle/',
  '/comuni/giovinazzo.html': '/comuni/giovinazzo/',
  '/comuni/giuggianello.html': '/comuni/giuggianello/',
  '/comuni/giurdignano.html': '/comuni/giurdignano/',
  '/comuni/gravina_in_puglia.html': '/comuni/gravina_in_puglia/',
  '/comuni/grottaglie.html': '/comuni/grottaglie/',
  '/comuni/grumo_appula.html': '/comuni/grumo_appula/',
  '/comuni/guagnano.html': '/comuni/guagnano/',
  '/comuni/ischitella.html': '/comuni/ischitella/',
  '/comuni/isole_tremiti.html': '/comuni/isole_tremiti/',
  '/comuni/laterza.html': '/comuni/laterza/',
  '/comuni/latiano.html': '/comuni/latiano/',
  '/comuni/lecce.html': '/comuni/lecce/',
  '/comuni/leporano.html': '/comuni/leporano/',
  '/comuni/lequile.html': '/comuni/lequile/',
  '/comuni/lesina.html': '/comuni/lesina/',
  '/comuni/leverano.html': '/comuni/leverano/',
  '/comuni/lizzanello.html': '/comuni/lizzanello/',
  '/comuni/lizzano.html': '/comuni/lizzano/',
  '/comuni/locorotondo.html': '/comuni/locorotondo/',
  '/comuni/lucera.html': '/comuni/lucera/',
  '/comuni/maglie.html': '/comuni/maglie/',
  '/comuni/manduria.html': '/comuni/manduria/',
  '/comuni/manfredonia.html': '/comuni/manfredonia/',
  '/comuni/margherita_di_savoia.html': '/comuni/margherita_di_savoia/',
  '/comuni/martano.html': '/comuni/martano/',
  '/comuni/martignano.html': '/comuni/martignano/',
  '/comuni/martina_franca.html': '/comuni/martina_franca/',
  '/comuni/maruggio.html': '/comuni/maruggio/',
  '/comuni/massafra.html': '/comuni/massafra/',
  '/comuni/matino.html': '/comuni/matino/',
  '/comuni/mattinata.html': '/comuni/mattinata/',
  '/comuni/melendugno.html': '/comuni/melendugno/',
  '/comuni/melissano.html': '/comuni/melissano/',
  '/comuni/melpignano.html': '/comuni/melpignano/',
  '/comuni/mesagne.html': '/comuni/mesagne/',
  '/comuni/miggiano.html': '/comuni/miggiano/',
  '/comuni/minervino_di_lecce.html': '/comuni/minervino_di_lecce/',
  '/comuni/minervino_murge.html': '/comuni/minervino_murge/',
  '/comuni/modugno.html': '/comuni/modugno/',
  '/comuni/mola_di_bari.html': '/comuni/mola_di_bari/',
  '/comuni/molfetta.html': '/comuni/molfetta/',
  '/comuni/monopoli.html': '/comuni/monopoli/',
  '/comuni/monte_santangelo.html': '/comuni/monte_santangelo/',
  '/comuni/monteiasi.html': '/comuni/monteiasi/',
  '/comuni/monteleone_di_puglia.html': '/comuni/monteleone_di_puglia/',
  '/comuni/montemesola.html': '/comuni/montemesola/',
  '/comuni/monteparano.html': '/comuni/monteparano/',
  '/comuni/monteroni_di_lecce.html': '/comuni/monteroni_di_lecce/',
  '/comuni/montesano_salentino.html': '/comuni/montesano_salentino/',
  '/comuni/morciano_di_leuca.html': '/comuni/morciano_di_leuca/',
  '/comuni/motta_montecorvino.html': '/comuni/motta_montecorvino/',
  '/comuni/mottola.html': '/comuni/mottola/',
  '/comuni/muro_leccese.html': '/comuni/muro_leccese/',
  '/comuni/nardo.html': '/comuni/nardo/',
  '/comuni/neviano.html': '/comuni/neviano/',
  '/comuni/noci.html': '/comuni/noci/',
  '/comuni/nociglia.html': '/comuni/nociglia/',
  '/comuni/noicattaro.html': '/comuni/noicattaro/',
  '/comuni/novoli.html': '/comuni/novoli/',
  '/comuni/ordona.html': '/comuni/ordona/',
  '/comuni/oria.html': '/comuni/oria/',
  '/comuni/orsara_di_puglia.html': '/comuni/orsara_di_puglia/',
  '/comuni/orta_nova.html': '/comuni/orta_nova/',
  '/comuni/ortelle.html': '/comuni/ortelle/',
  '/comuni/ostuni.html': '/comuni/ostuni/',
  '/comuni/otranto.html': '/comuni/otranto/',
  '/comuni/palagianello.html': '/comuni/palagianello/',
  '/comuni/palagiano.html': '/comuni/palagiano/',
  '/comuni/palmariggi.html': '/comuni/palmariggi/',
  '/comuni/palo_del_colle.html': '/comuni/palo_del_colle/',
  '/comuni/panni.html': '/comuni/panni/',
  '/comuni/parabita.html': '/comuni/parabita/',
  '/comuni/patu.html': '/comuni/patu/',
  '/comuni/peschici.html': '/comuni/peschici/',
  '/comuni/pietramontecorvino.html': '/comuni/pietramontecorvino/',
  '/comuni/poggiardo.html': '/comuni/poggiardo/',
  '/comuni/poggio_imperiale.html': '/comuni/poggio_imperiale/',
  '/comuni/poggiorsini.html': '/comuni/poggiorsini/',
  '/comuni/polignano_a_mare.html': '/comuni/polignano_a_mare/',
  '/comuni/porto_cesareo.html': '/comuni/porto_cesareo/',
  '/comuni/presicce-acquarica.html': '/comuni/presicce-acquarica/',
  '/comuni/pulsano.html': '/comuni/pulsano/',
  '/comuni/putignano.html': '/comuni/putignano/',
  '/comuni/racale.html': '/comuni/racale/',
  '/comuni/rignano_garganico.html': '/comuni/rignano_garganico/',
  '/comuni/roccaforzata.html': '/comuni/roccaforzata/',
  '/comuni/rocchetta_santantonio.html': '/comuni/rocchetta_santantonio/',
  '/comuni/rodi_garganico.html': '/comuni/rodi_garganico/',
  '/comuni/roseto_valfortore.html': '/comuni/roseto_valfortore/',
  '/comuni/ruffano.html': '/comuni/ruffano/',
  '/comuni/rutigliano.html': '/comuni/rutigliano/',
  '/comuni/ruvo_di_puglia.html': '/comuni/ruvo_di_puglia/',
  '/comuni/salice_salentino.html': '/comuni/salice_salentino/',
  '/comuni/salve.html': '/comuni/salve/',
  '/comuni/sammichele_di_bari.html': '/comuni/sammichele_di_bari/',
  '/comuni/san_cassiano.html': '/comuni/san_cassiano/',
  '/comuni/san_cesario_di_lecce.html': '/comuni/san_cesario_di_lecce/',
  '/comuni/san_donaci.html': '/comuni/san_donaci/',
  '/comuni/san_donato_di_lecce.html': '/comuni/san_donato_di_lecce/',
  '/comuni/san_ferdinando_di_puglia.html': '/comuni/san_ferdinando_di_puglia/',
  '/comuni/san_giorgio_ionico.html': '/comuni/san_giorgio_ionico/',
  '/comuni/san_giovanni_rotondo.html': '/comuni/san_giovanni_rotondo/',
  '/comuni/san_marco_in_lamis.html': '/comuni/san_marco_in_lamis/',
  '/comuni/san_marco_la_catola.html': '/comuni/san_marco_la_catola/',
  '/comuni/san_marzano_di_san_giuseppe.html': '/comuni/san_marzano_di_san_giuseppe/',
  '/comuni/san_michele_salentino.html': '/comuni/san_michele_salentino/',
  '/comuni/san_nicandro_garganico.html': '/comuni/san_nicandro_garganico/',
  '/comuni/san_pancrazio_salentino.html': '/comuni/san_pancrazio_salentino/',
  '/comuni/san_paolo_di_civitate.html': '/comuni/san_paolo_di_civitate/',
  '/comuni/san_pietro_in_lama.html': '/comuni/san_pietro_in_lama/',
  '/comuni/san_pietro_vernotico.html': '/comuni/san_pietro_vernotico/',
  '/comuni/san_severo.html': '/comuni/san_severo/',
  '/comuni/san_vito_dei_normanni.html': '/comuni/san_vito_dei_normanni/',
  '/comuni/sanarica.html': '/comuni/sanarica/',
  '/comuni/sannicandro_di_bari.html': '/comuni/sannicandro_di_bari/',
  '/comuni/sannicola.html': '/comuni/sannicola/',
  '/comuni/santa_cesarea_terme.html': '/comuni/santa_cesarea_terme/',
  '/comuni/santagata_di_puglia.html': '/comuni/santagata_di_puglia/',
  '/comuni/santeramo_in_colle.html': '/comuni/santeramo_in_colle/',
  '/comuni/sava.html': '/comuni/sava/',
  '/comuni/scorrano.html': '/comuni/scorrano/',
  '/comuni/secli.html': '/comuni/secli/',
  '/comuni/serracapriola.html': '/comuni/serracapriola/',
  '/comuni/sogliano_cavour.html': '/comuni/sogliano_cavour/',
  '/comuni/soleto.html': '/comuni/soleto/',
  '/comuni/specchia.html': '/comuni/specchia/',
  '/comuni/spinazzola.html': '/comuni/spinazzola/',
  '/comuni/spongano.html': '/comuni/spongano/',
  '/comuni/squinzano.html': '/comuni/squinzano/',
  '/comuni/statte.html': '/comuni/statte/',
  '/comuni/sternatia.html': '/comuni/sternatia/',
  '/comuni/stornara.html': '/comuni/stornara/',
  '/comuni/stornarella.html': '/comuni/stornarella/',
  '/comuni/supersano.html': '/comuni/supersano/',
  '/comuni/surano.html': '/comuni/surano/',
  '/comuni/surbo.html': '/comuni/surbo/',
  '/comuni/taranto.html': '/comuni/taranto/',
  '/comuni/taurisano.html': '/comuni/taurisano/',
  '/comuni/taviano.html': '/comuni/taviano/',
  '/comuni/terlizzi.html': '/comuni/terlizzi/',
  '/comuni/tiggiano.html': '/comuni/tiggiano/',
  '/comuni/torchiarolo.html': '/comuni/torchiarolo/',
  '/comuni/toritto.html': '/comuni/toritto/',
  '/comuni/torre_santa_susanna.html': '/comuni/torre_santa_susanna/',
  '/comuni/torremaggiore.html': '/comuni/torremaggiore/',
  '/comuni/torricella.html': '/comuni/torricella/',
  '/comuni/trani.html': '/comuni/trani/',
  '/comuni/trepuzzi.html': '/comuni/trepuzzi/',
  '/comuni/tricase.html': '/comuni/tricase/',
  '/comuni/triggiano.html': '/comuni/triggiano/',
  '/comuni/trinitapoli.html': '/comuni/trinitapoli/',
  '/comuni/troia.html': '/comuni/troia/',
  '/comuni/tuglie.html': '/comuni/tuglie/',
  '/comuni/turi.html': '/comuni/turi/',
  '/comuni/ugento.html': '/comuni/ugento/',
  '/comuni/uggiano_la_chiesa.html': '/comuni/uggiano_la_chiesa/',
  '/comuni/valenzano.html': '/comuni/valenzano/',
  '/comuni/veglie.html': '/comuni/veglie/',
  '/comuni/vernole.html': '/comuni/vernole/',
  '/comuni/vico_del_gargano.html': '/comuni/vico_del_gargano/',
  '/comuni/vieste.html': '/comuni/vieste/',
  '/comuni/villa_castelli.html': '/comuni/villa_castelli/',
  '/comuni/volturara_appula.html': '/comuni/volturara_appula/',
  '/comuni/volturino.html': '/comuni/volturino/',
  '/comuni/zapponeta.html': '/comuni/zapponeta/',
  '/index.html': '/',
  '/puglia/': '/',
  '/puglia/404.html': '/404',
  '/puglia/admin/': '/admin/',
  '/puglia/admin/comune.html': '/admin/comune/',
  '/puglia/admin/index.html': '/admin/',
  '/puglia/admin/submissions.html': '/admin/moderazione/',
  // Aggiornato a mano il 31/07/2026: /api/docs/ è oscurato dal proxy /api/*,
  // la rotta pubblica è /docs-api/ (decisione utente, visual-diff voci 1-2).
  '/puglia/api/docs.html': '/docs-api/',
  '/puglia/area/': '/admin/',
  '/puglia/assistenza/assistente.html': '/assistenza/assistente/',
  '/puglia/assistenza/cerca.html': '/cerca/',
  '/puglia/assistenza/chat.html': '/assistenza/assistente/',
  '/puglia/attivita/gusta-attivita.html': '/attivita/',
  '/puglia/attivita/modifica-attivita.html': '/attivita/modifica/',
  '/puglia/attivita/proponi-attivita.html': '/attivita/proponi/',
  '/puglia/cammini/': '/itinerari/',
  '/puglia/cammini/index.html': '/itinerari/',
  '/puglia/cammini/itinerario-barocco-salentino.html': '/itinerari/barocco-salentino/',
  '/puglia/cammini/itinerario-borghi-piu-belli.html': '/itinerari/borghi-piu-belli/',
  '/puglia/cammini/itinerario-cammino-materano.html': '/itinerari/cammino-materano/',
  '/puglia/cammini/itinerario-castelli-federiciani.html': '/itinerari/castelli-federiciani/',
  '/puglia/cammini/itinerario-cattedrali-romaniche.html': '/itinerari/cattedrali-romaniche/',
  '/puglia/cammini/itinerario-costa-adriatica.html': '/itinerari/costa-adriatica/',
  '/puglia/cammini/itinerario-costa-ionica-salento.html': '/itinerari/costa-ionica-salento/',
  '/puglia/cammini/itinerario-dune-costiere.html': '/itinerari/dune-costiere/',
  '/puglia/cammini/itinerario-francigena-sud.html': '/itinerari/francigena-sud/',
  '/puglia/cammini/itinerario-parco-alta-murgia.html': '/itinerari/parco-alta-murgia/',
  '/puglia/cammini/itinerario-parco-gargano.html': '/itinerari/parco-gargano/',
  '/puglia/cammini/itinerario-saline-margherita.html': '/itinerari/saline-margherita/',
  '/puglia/cammini/itinerario-trulli-valle-itria.html': '/itinerari/trulli-valle-itria/',
  '/puglia/cammini/itinerario-via-appia.html': '/itinerari/via-appia/',
  '/puglia/cammini/itinerario-via-traiana.html': '/itinerari/via-traiana/',
  '/puglia/comuni/': '/comuni/',
  '/puglia/comuni/accadia.html': '/comuni/accadia/',
  '/puglia/comuni/accadia/': '/comuni/accadia/',
  '/puglia/comuni/accadia/index.html': '/comuni/accadia/',
  '/puglia/comuni/acquarica_del_capo.html': '/comuni/acquarica_del_capo/',
  '/puglia/comuni/acquarica_del_capo/': '/comuni/acquarica_del_capo/',
  '/puglia/comuni/acquarica_del_capo/index.html': '/comuni/acquarica_del_capo/',
  '/puglia/comuni/acquaviva_delle_fonti.html': '/comuni/acquaviva_delle_fonti/',
  '/puglia/comuni/acquaviva_delle_fonti/': '/comuni/acquaviva_delle_fonti/',
  '/puglia/comuni/acquaviva_delle_fonti/index.html': '/comuni/acquaviva_delle_fonti/',
  '/puglia/comuni/adelfia.html': '/comuni/adelfia/',
  '/puglia/comuni/adelfia/': '/comuni/adelfia/',
  '/puglia/comuni/adelfia/index.html': '/comuni/adelfia/',
  '/puglia/comuni/alberobello.html': '/comuni/alberobello/',
  '/puglia/comuni/alberobello/': '/comuni/alberobello/',
  '/puglia/comuni/alberobello/index.html': '/comuni/alberobello/',
  '/puglia/comuni/alberona.html': '/comuni/alberona/',
  '/puglia/comuni/alberona/': '/comuni/alberona/',
  '/puglia/comuni/alberona/index.html': '/comuni/alberona/',
  '/puglia/comuni/alessano.html': '/comuni/alessano/',
  '/puglia/comuni/alessano/': '/comuni/alessano/',
  '/puglia/comuni/alessano/index.html': '/comuni/alessano/',
  '/puglia/comuni/alezio.html': '/comuni/alezio/',
  '/puglia/comuni/alezio/': '/comuni/alezio/',
  '/puglia/comuni/alezio/index.html': '/comuni/alezio/',
  '/puglia/comuni/alliste.html': '/comuni/alliste/',
  '/puglia/comuni/alliste/': '/comuni/alliste/',
  '/puglia/comuni/alliste/index.html': '/comuni/alliste/',
  '/puglia/comuni/altamura.html': '/comuni/altamura/',
  '/puglia/comuni/altamura/': '/comuni/altamura/',
  '/puglia/comuni/altamura/index.html': '/comuni/altamura/',
  '/puglia/comuni/andrano.html': '/comuni/andrano/',
  '/puglia/comuni/andrano/': '/comuni/andrano/',
  '/puglia/comuni/andrano/index.html': '/comuni/andrano/',
  '/puglia/comuni/andria.html': '/comuni/andria/',
  '/puglia/comuni/andria/': '/comuni/andria/',
  '/puglia/comuni/andria/index.html': '/comuni/andria/',
  '/puglia/comuni/anzano_di_puglia.html': '/comuni/anzano_di_puglia/',
  '/puglia/comuni/anzano_di_puglia/': '/comuni/anzano_di_puglia/',
  '/puglia/comuni/anzano_di_puglia/index.html': '/comuni/anzano_di_puglia/',
  '/puglia/comuni/apricena.html': '/comuni/apricena/',
  '/puglia/comuni/apricena/': '/comuni/apricena/',
  '/puglia/comuni/apricena/index.html': '/comuni/apricena/',
  '/puglia/comuni/aradeo.html': '/comuni/aradeo/',
  '/puglia/comuni/aradeo/': '/comuni/aradeo/',
  '/puglia/comuni/aradeo/index.html': '/comuni/aradeo/',
  '/puglia/comuni/arnesano.html': '/comuni/arnesano/',
  '/puglia/comuni/arnesano/': '/comuni/arnesano/',
  '/puglia/comuni/arnesano/index.html': '/comuni/arnesano/',
  '/puglia/comuni/ascoli_satriano.html': '/comuni/ascoli_satriano/',
  '/puglia/comuni/ascoli_satriano/': '/comuni/ascoli_satriano/',
  '/puglia/comuni/ascoli_satriano/index.html': '/comuni/ascoli_satriano/',
  '/puglia/comuni/avetrana.html': '/comuni/avetrana/',
  '/puglia/comuni/avetrana/': '/comuni/avetrana/',
  '/puglia/comuni/avetrana/index.html': '/comuni/avetrana/',
  '/puglia/comuni/bagnolo_del_salento.html': '/comuni/bagnolo_del_salento/',
  '/puglia/comuni/bagnolo_del_salento/': '/comuni/bagnolo_del_salento/',
  '/puglia/comuni/bagnolo_del_salento/index.html': '/comuni/bagnolo_del_salento/',
  '/puglia/comuni/bari.html': '/comuni/bari/',
  '/puglia/comuni/bari/': '/comuni/bari/',
  '/puglia/comuni/bari/index.html': '/comuni/bari/',
  '/puglia/comuni/barletta.html': '/comuni/barletta/',
  '/puglia/comuni/barletta/': '/comuni/barletta/',
  '/puglia/comuni/barletta/index.html': '/comuni/barletta/',
  '/puglia/comuni/biccari.html': '/comuni/biccari/',
  '/puglia/comuni/biccari/': '/comuni/biccari/',
  '/puglia/comuni/biccari/index.html': '/comuni/biccari/',
  '/puglia/comuni/binetto.html': '/comuni/binetto/',
  '/puglia/comuni/binetto/': '/comuni/binetto/',
  '/puglia/comuni/binetto/index.html': '/comuni/binetto/',
  '/puglia/comuni/bisceglie.html': '/comuni/bisceglie/',
  '/puglia/comuni/bisceglie/': '/comuni/bisceglie/',
  '/puglia/comuni/bisceglie/index.html': '/comuni/bisceglie/',
  '/puglia/comuni/bitetto.html': '/comuni/bitetto/',
  '/puglia/comuni/bitetto/': '/comuni/bitetto/',
  '/puglia/comuni/bitetto/index.html': '/comuni/bitetto/',
  '/puglia/comuni/bitonto.html': '/comuni/bitonto/',
  '/puglia/comuni/bitonto/': '/comuni/bitonto/',
  '/puglia/comuni/bitonto/index.html': '/comuni/bitonto/',
  '/puglia/comuni/bitritto.html': '/comuni/bitritto/',
  '/puglia/comuni/bitritto/': '/comuni/bitritto/',
  '/puglia/comuni/bitritto/index.html': '/comuni/bitritto/',
  '/puglia/comuni/botrugno.html': '/comuni/botrugno/',
  '/puglia/comuni/botrugno/': '/comuni/botrugno/',
  '/puglia/comuni/botrugno/index.html': '/comuni/botrugno/',
  '/puglia/comuni/bovino.html': '/comuni/bovino/',
  '/puglia/comuni/bovino/': '/comuni/bovino/',
  '/puglia/comuni/bovino/index.html': '/comuni/bovino/',
  '/puglia/comuni/brindisi.html': '/comuni/brindisi/',
  '/puglia/comuni/brindisi/': '/comuni/brindisi/',
  '/puglia/comuni/brindisi/index.html': '/comuni/brindisi/',
  '/puglia/comuni/cagnano_varano.html': '/comuni/cagnano_varano/',
  '/puglia/comuni/cagnano_varano/': '/comuni/cagnano_varano/',
  '/puglia/comuni/cagnano_varano/index.html': '/comuni/cagnano_varano/',
  '/puglia/comuni/calimera.html': '/comuni/calimera/',
  '/puglia/comuni/calimera/': '/comuni/calimera/',
  '/puglia/comuni/calimera/index.html': '/comuni/calimera/',
  '/puglia/comuni/campi_salentina.html': '/comuni/campi_salentina/',
  '/puglia/comuni/campi_salentina/': '/comuni/campi_salentina/',
  '/puglia/comuni/campi_salentina/index.html': '/comuni/campi_salentina/',
  '/puglia/comuni/candela.html': '/comuni/candela/',
  '/puglia/comuni/candela/': '/comuni/candela/',
  '/puglia/comuni/candela/index.html': '/comuni/candela/',
  '/puglia/comuni/cannole.html': '/comuni/cannole/',
  '/puglia/comuni/cannole/': '/comuni/cannole/',
  '/puglia/comuni/cannole/index.html': '/comuni/cannole/',
  '/puglia/comuni/canosa_di_puglia.html': '/comuni/canosa_di_puglia/',
  '/puglia/comuni/canosa_di_puglia/': '/comuni/canosa_di_puglia/',
  '/puglia/comuni/canosa_di_puglia/index.html': '/comuni/canosa_di_puglia/',
  '/puglia/comuni/caprarica_di_lecce.html': '/comuni/caprarica_di_lecce/',
  '/puglia/comuni/caprarica_di_lecce/': '/comuni/caprarica_di_lecce/',
  '/puglia/comuni/caprarica_di_lecce/index.html': '/comuni/caprarica_di_lecce/',
  '/puglia/comuni/capurso.html': '/comuni/capurso/',
  '/puglia/comuni/capurso/': '/comuni/capurso/',
  '/puglia/comuni/capurso/index.html': '/comuni/capurso/',
  '/puglia/comuni/carapelle.html': '/comuni/carapelle/',
  '/puglia/comuni/carapelle/': '/comuni/carapelle/',
  '/puglia/comuni/carapelle/index.html': '/comuni/carapelle/',
  '/puglia/comuni/carlantino.html': '/comuni/carlantino/',
  '/puglia/comuni/carlantino/': '/comuni/carlantino/',
  '/puglia/comuni/carlantino/index.html': '/comuni/carlantino/',
  '/puglia/comuni/carmiano.html': '/comuni/carmiano/',
  '/puglia/comuni/carmiano/': '/comuni/carmiano/',
  '/puglia/comuni/carmiano/index.html': '/comuni/carmiano/',
  '/puglia/comuni/carosino.html': '/comuni/carosino/',
  '/puglia/comuni/carosino/': '/comuni/carosino/',
  '/puglia/comuni/carosino/index.html': '/comuni/carosino/',
  '/puglia/comuni/carovigno.html': '/comuni/carovigno/',
  '/puglia/comuni/carovigno/': '/comuni/carovigno/',
  '/puglia/comuni/carovigno/index.html': '/comuni/carovigno/',
  '/puglia/comuni/carpignano_salentino.html': '/comuni/carpignano_salentino/',
  '/puglia/comuni/carpignano_salentino/': '/comuni/carpignano_salentino/',
  '/puglia/comuni/carpignano_salentino/index.html': '/comuni/carpignano_salentino/',
  '/puglia/comuni/carpino.html': '/comuni/carpino/',
  '/puglia/comuni/carpino/': '/comuni/carpino/',
  '/puglia/comuni/carpino/index.html': '/comuni/carpino/',
  '/puglia/comuni/casalnuovo_monterotaro.html': '/comuni/casalnuovo_monterotaro/',
  '/puglia/comuni/casalnuovo_monterotaro/': '/comuni/casalnuovo_monterotaro/',
  '/puglia/comuni/casalnuovo_monterotaro/index.html': '/comuni/casalnuovo_monterotaro/',
  '/puglia/comuni/casalvecchio_di_puglia.html': '/comuni/casalvecchio_di_puglia/',
  '/puglia/comuni/casalvecchio_di_puglia/': '/comuni/casalvecchio_di_puglia/',
  '/puglia/comuni/casalvecchio_di_puglia/index.html': '/comuni/casalvecchio_di_puglia/',
  '/puglia/comuni/casamassima.html': '/comuni/casamassima/',
  '/puglia/comuni/casamassima/': '/comuni/casamassima/',
  '/puglia/comuni/casamassima/index.html': '/comuni/casamassima/',
  '/puglia/comuni/casarano.html': '/comuni/casarano/',
  '/puglia/comuni/casarano/': '/comuni/casarano/',
  '/puglia/comuni/casarano/index.html': '/comuni/casarano/',
  '/puglia/comuni/cassano_delle_murge.html': '/comuni/cassano_delle_murge/',
  '/puglia/comuni/cassano_delle_murge/': '/comuni/cassano_delle_murge/',
  '/puglia/comuni/cassano_delle_murge/index.html': '/comuni/cassano_delle_murge/',
  '/puglia/comuni/castellana_grotte.html': '/comuni/castellana_grotte/',
  '/puglia/comuni/castellana_grotte/': '/comuni/castellana_grotte/',
  '/puglia/comuni/castellana_grotte/index.html': '/comuni/castellana_grotte/',
  '/puglia/comuni/castellaneta.html': '/comuni/castellaneta/',
  '/puglia/comuni/castellaneta/': '/comuni/castellaneta/',
  '/puglia/comuni/castellaneta/index.html': '/comuni/castellaneta/',
  '/puglia/comuni/castelluccio_dei_sauri.html': '/comuni/castelluccio_dei_sauri/',
  '/puglia/comuni/castelluccio_dei_sauri/': '/comuni/castelluccio_dei_sauri/',
  '/puglia/comuni/castelluccio_dei_sauri/index.html': '/comuni/castelluccio_dei_sauri/',
  '/puglia/comuni/castelluccio_valmaggiore.html': '/comuni/castelluccio_valmaggiore/',
  '/puglia/comuni/castelluccio_valmaggiore/': '/comuni/castelluccio_valmaggiore/',
  '/puglia/comuni/castelluccio_valmaggiore/index.html': '/comuni/castelluccio_valmaggiore/',
  '/puglia/comuni/castelnuovo_della_daunia.html': '/comuni/castelnuovo_della_daunia/',
  '/puglia/comuni/castelnuovo_della_daunia/': '/comuni/castelnuovo_della_daunia/',
  '/puglia/comuni/castelnuovo_della_daunia/index.html': '/comuni/castelnuovo_della_daunia/',
  '/puglia/comuni/castri_di_lecce.html': '/comuni/castri_di_lecce/',
  '/puglia/comuni/castri_di_lecce/': '/comuni/castri_di_lecce/',
  '/puglia/comuni/castri_di_lecce/index.html': '/comuni/castri_di_lecce/',
  '/puglia/comuni/castrignano_de_greci.html': '/comuni/castrignano_de_greci/',
  '/puglia/comuni/castrignano_de_greci/': '/comuni/castrignano_de_greci/',
  '/puglia/comuni/castrignano_de_greci/index.html': '/comuni/castrignano_de_greci/',
  '/puglia/comuni/castrignano_del_capo.html': '/comuni/castrignano_del_capo/',
  '/puglia/comuni/castrignano_del_capo/': '/comuni/castrignano_del_capo/',
  '/puglia/comuni/castrignano_del_capo/index.html': '/comuni/castrignano_del_capo/',
  '/puglia/comuni/castro.html': '/comuni/castro/',
  '/puglia/comuni/castro/': '/comuni/castro/',
  '/puglia/comuni/castro/index.html': '/comuni/castro/',
  '/puglia/comuni/cavallino.html': '/comuni/cavallino/',
  '/puglia/comuni/cavallino/': '/comuni/cavallino/',
  '/puglia/comuni/cavallino/index.html': '/comuni/cavallino/',
  '/puglia/comuni/ceglie_messapica.html': '/comuni/ceglie_messapica/',
  '/puglia/comuni/ceglie_messapica/': '/comuni/ceglie_messapica/',
  '/puglia/comuni/ceglie_messapica/index.html': '/comuni/ceglie_messapica/',
  '/puglia/comuni/celenza_valfortore.html': '/comuni/celenza_valfortore/',
  '/puglia/comuni/celenza_valfortore/': '/comuni/celenza_valfortore/',
  '/puglia/comuni/celenza_valfortore/index.html': '/comuni/celenza_valfortore/',
  '/puglia/comuni/cellamare.html': '/comuni/cellamare/',
  '/puglia/comuni/cellamare/': '/comuni/cellamare/',
  '/puglia/comuni/cellamare/index.html': '/comuni/cellamare/',
  '/puglia/comuni/celle_di_san_vito.html': '/comuni/celle_di_san_vito/',
  '/puglia/comuni/celle_di_san_vito/': '/comuni/celle_di_san_vito/',
  '/puglia/comuni/celle_di_san_vito/index.html': '/comuni/celle_di_san_vito/',
  '/puglia/comuni/cellino_san_marco.html': '/comuni/cellino_san_marco/',
  '/puglia/comuni/cellino_san_marco/': '/comuni/cellino_san_marco/',
  '/puglia/comuni/cellino_san_marco/index.html': '/comuni/cellino_san_marco/',
  '/puglia/comuni/cerignola.html': '/comuni/cerignola/',
  '/puglia/comuni/cerignola/': '/comuni/cerignola/',
  '/puglia/comuni/cerignola/index.html': '/comuni/cerignola/',
  '/puglia/comuni/chieuti.html': '/comuni/chieuti/',
  '/puglia/comuni/chieuti/': '/comuni/chieuti/',
  '/puglia/comuni/chieuti/index.html': '/comuni/chieuti/',
  '/puglia/comuni/cisternino.html': '/comuni/cisternino/',
  '/puglia/comuni/cisternino/': '/comuni/cisternino/',
  '/puglia/comuni/cisternino/index.html': '/comuni/cisternino/',
  '/puglia/comuni/collepasso.html': '/comuni/collepasso/',
  '/puglia/comuni/collepasso/': '/comuni/collepasso/',
  '/puglia/comuni/collepasso/index.html': '/comuni/collepasso/',
  '/puglia/comuni/conversano.html': '/comuni/conversano/',
  '/puglia/comuni/conversano/': '/comuni/conversano/',
  '/puglia/comuni/conversano/index.html': '/comuni/conversano/',
  '/puglia/comuni/copertino.html': '/comuni/copertino/',
  '/puglia/comuni/copertino/': '/comuni/copertino/',
  '/puglia/comuni/copertino/index.html': '/comuni/copertino/',
  '/puglia/comuni/corato.html': '/comuni/corato/',
  '/puglia/comuni/corato/': '/comuni/corato/',
  '/puglia/comuni/corato/index.html': '/comuni/corato/',
  '/puglia/comuni/corigliano_dotranto.html': '/comuni/corigliano_dotranto/',
  '/puglia/comuni/corigliano_dotranto/': '/comuni/corigliano_dotranto/',
  '/puglia/comuni/corigliano_dotranto/index.html': '/comuni/corigliano_dotranto/',
  '/puglia/comuni/corsano.html': '/comuni/corsano/',
  '/puglia/comuni/corsano/': '/comuni/corsano/',
  '/puglia/comuni/corsano/index.html': '/comuni/corsano/',
  '/puglia/comuni/crispiano.html': '/comuni/crispiano/',
  '/puglia/comuni/crispiano/': '/comuni/crispiano/',
  '/puglia/comuni/crispiano/index.html': '/comuni/crispiano/',
  '/puglia/comuni/cursi.html': '/comuni/cursi/',
  '/puglia/comuni/cursi/': '/comuni/cursi/',
  '/puglia/comuni/cursi/index.html': '/comuni/cursi/',
  '/puglia/comuni/cutrofiano.html': '/comuni/cutrofiano/',
  '/puglia/comuni/cutrofiano/': '/comuni/cutrofiano/',
  '/puglia/comuni/cutrofiano/index.html': '/comuni/cutrofiano/',
  '/puglia/comuni/deliceto.html': '/comuni/deliceto/',
  '/puglia/comuni/deliceto/': '/comuni/deliceto/',
  '/puglia/comuni/deliceto/index.html': '/comuni/deliceto/',
  '/puglia/comuni/diso.html': '/comuni/diso/',
  '/puglia/comuni/diso/': '/comuni/diso/',
  '/puglia/comuni/diso/index.html': '/comuni/diso/',
  '/puglia/comuni/erchie.html': '/comuni/erchie/',
  '/puglia/comuni/erchie/': '/comuni/erchie/',
  '/puglia/comuni/erchie/index.html': '/comuni/erchie/',
  '/puglia/comuni/faeto.html': '/comuni/faeto/',
  '/puglia/comuni/faeto/': '/comuni/faeto/',
  '/puglia/comuni/faeto/index.html': '/comuni/faeto/',
  '/puglia/comuni/faggiano.html': '/comuni/faggiano/',
  '/puglia/comuni/faggiano/': '/comuni/faggiano/',
  '/puglia/comuni/faggiano/index.html': '/comuni/faggiano/',
  '/puglia/comuni/fasano.html': '/comuni/fasano/',
  '/puglia/comuni/fasano/': '/comuni/fasano/',
  '/puglia/comuni/fasano/index.html': '/comuni/fasano/',
  '/puglia/comuni/foggia.html': '/comuni/foggia/',
  '/puglia/comuni/foggia/': '/comuni/foggia/',
  '/puglia/comuni/foggia/index.html': '/comuni/foggia/',
  '/puglia/comuni/fragagnano.html': '/comuni/fragagnano/',
  '/puglia/comuni/fragagnano/': '/comuni/fragagnano/',
  '/puglia/comuni/fragagnano/index.html': '/comuni/fragagnano/',
  '/puglia/comuni/francavilla_fontana.html': '/comuni/francavilla_fontana/',
  '/puglia/comuni/francavilla_fontana/': '/comuni/francavilla_fontana/',
  '/puglia/comuni/francavilla_fontana/index.html': '/comuni/francavilla_fontana/',
  '/puglia/comuni/gagliano_del_capo.html': '/comuni/gagliano_del_capo/',
  '/puglia/comuni/gagliano_del_capo/': '/comuni/gagliano_del_capo/',
  '/puglia/comuni/gagliano_del_capo/index.html': '/comuni/gagliano_del_capo/',
  '/puglia/comuni/galatina.html': '/comuni/galatina/',
  '/puglia/comuni/galatina/': '/comuni/galatina/',
  '/puglia/comuni/galatina/index.html': '/comuni/galatina/',
  '/puglia/comuni/galatone.html': '/comuni/galatone/',
  '/puglia/comuni/galatone/': '/comuni/galatone/',
  '/puglia/comuni/galatone/index.html': '/comuni/galatone/',
  '/puglia/comuni/gallipoli.html': '/comuni/gallipoli/',
  '/puglia/comuni/gallipoli/': '/comuni/gallipoli/',
  '/puglia/comuni/gallipoli/index.html': '/comuni/gallipoli/',
  '/puglia/comuni/ginosa.html': '/comuni/ginosa/',
  '/puglia/comuni/ginosa/': '/comuni/ginosa/',
  '/puglia/comuni/ginosa/index.html': '/comuni/ginosa/',
  '/puglia/comuni/gioia_del_colle.html': '/comuni/gioia_del_colle/',
  '/puglia/comuni/gioia_del_colle/': '/comuni/gioia_del_colle/',
  '/puglia/comuni/gioia_del_colle/index.html': '/comuni/gioia_del_colle/',
  '/puglia/comuni/giovinazzo.html': '/comuni/giovinazzo/',
  '/puglia/comuni/giovinazzo/': '/comuni/giovinazzo/',
  '/puglia/comuni/giovinazzo/index.html': '/comuni/giovinazzo/',
  '/puglia/comuni/giuggianello.html': '/comuni/giuggianello/',
  '/puglia/comuni/giuggianello/': '/comuni/giuggianello/',
  '/puglia/comuni/giuggianello/index.html': '/comuni/giuggianello/',
  '/puglia/comuni/giurdignano.html': '/comuni/giurdignano/',
  '/puglia/comuni/giurdignano/': '/comuni/giurdignano/',
  '/puglia/comuni/giurdignano/index.html': '/comuni/giurdignano/',
  '/puglia/comuni/gravina_in_puglia.html': '/comuni/gravina_in_puglia/',
  '/puglia/comuni/gravina_in_puglia/': '/comuni/gravina_in_puglia/',
  '/puglia/comuni/gravina_in_puglia/index.html': '/comuni/gravina_in_puglia/',
  '/puglia/comuni/grottaglie.html': '/comuni/grottaglie/',
  '/puglia/comuni/grottaglie/': '/comuni/grottaglie/',
  '/puglia/comuni/grottaglie/index.html': '/comuni/grottaglie/',
  '/puglia/comuni/grumo_appula.html': '/comuni/grumo_appula/',
  '/puglia/comuni/grumo_appula/': '/comuni/grumo_appula/',
  '/puglia/comuni/grumo_appula/index.html': '/comuni/grumo_appula/',
  '/puglia/comuni/guagnano.html': '/comuni/guagnano/',
  '/puglia/comuni/guagnano/': '/comuni/guagnano/',
  '/puglia/comuni/guagnano/index.html': '/comuni/guagnano/',
  '/puglia/comuni/index.html': '/comuni/',
  '/puglia/comuni/ischitella.html': '/comuni/ischitella/',
  '/puglia/comuni/ischitella/': '/comuni/ischitella/',
  '/puglia/comuni/ischitella/index.html': '/comuni/ischitella/',
  '/puglia/comuni/isole_tremiti.html': '/comuni/isole_tremiti/',
  '/puglia/comuni/isole_tremiti/': '/comuni/isole_tremiti/',
  '/puglia/comuni/isole_tremiti/index.html': '/comuni/isole_tremiti/',
  '/puglia/comuni/laterza.html': '/comuni/laterza/',
  '/puglia/comuni/laterza/': '/comuni/laterza/',
  '/puglia/comuni/laterza/index.html': '/comuni/laterza/',
  '/puglia/comuni/latiano.html': '/comuni/latiano/',
  '/puglia/comuni/latiano/': '/comuni/latiano/',
  '/puglia/comuni/latiano/index.html': '/comuni/latiano/',
  '/puglia/comuni/lecce.html': '/comuni/lecce/',
  '/puglia/comuni/lecce/': '/comuni/lecce/',
  '/puglia/comuni/lecce/index.html': '/comuni/lecce/',
  '/puglia/comuni/leporano.html': '/comuni/leporano/',
  '/puglia/comuni/leporano/': '/comuni/leporano/',
  '/puglia/comuni/leporano/index.html': '/comuni/leporano/',
  '/puglia/comuni/lequile.html': '/comuni/lequile/',
  '/puglia/comuni/lequile/': '/comuni/lequile/',
  '/puglia/comuni/lequile/index.html': '/comuni/lequile/',
  '/puglia/comuni/lesina.html': '/comuni/lesina/',
  '/puglia/comuni/lesina/': '/comuni/lesina/',
  '/puglia/comuni/lesina/index.html': '/comuni/lesina/',
  '/puglia/comuni/leverano.html': '/comuni/leverano/',
  '/puglia/comuni/leverano/': '/comuni/leverano/',
  '/puglia/comuni/leverano/index.html': '/comuni/leverano/',
  '/puglia/comuni/lizzanello.html': '/comuni/lizzanello/',
  '/puglia/comuni/lizzanello/': '/comuni/lizzanello/',
  '/puglia/comuni/lizzanello/index.html': '/comuni/lizzanello/',
  '/puglia/comuni/lizzano.html': '/comuni/lizzano/',
  '/puglia/comuni/lizzano/': '/comuni/lizzano/',
  '/puglia/comuni/lizzano/index.html': '/comuni/lizzano/',
  '/puglia/comuni/locorotondo.html': '/comuni/locorotondo/',
  '/puglia/comuni/locorotondo/': '/comuni/locorotondo/',
  '/puglia/comuni/locorotondo/index.html': '/comuni/locorotondo/',
  '/puglia/comuni/lucera.html': '/comuni/lucera/',
  '/puglia/comuni/lucera/': '/comuni/lucera/',
  '/puglia/comuni/lucera/index.html': '/comuni/lucera/',
  '/puglia/comuni/maglie.html': '/comuni/maglie/',
  '/puglia/comuni/maglie/': '/comuni/maglie/',
  '/puglia/comuni/maglie/index.html': '/comuni/maglie/',
  '/puglia/comuni/manduria.html': '/comuni/manduria/',
  '/puglia/comuni/manduria/': '/comuni/manduria/',
  '/puglia/comuni/manduria/index.html': '/comuni/manduria/',
  '/puglia/comuni/manfredonia.html': '/comuni/manfredonia/',
  '/puglia/comuni/manfredonia/': '/comuni/manfredonia/',
  '/puglia/comuni/manfredonia/index.html': '/comuni/manfredonia/',
  '/puglia/comuni/margherita_di_savoia.html': '/comuni/margherita_di_savoia/',
  '/puglia/comuni/margherita_di_savoia/': '/comuni/margherita_di_savoia/',
  '/puglia/comuni/margherita_di_savoia/index.html': '/comuni/margherita_di_savoia/',
  '/puglia/comuni/martano.html': '/comuni/martano/',
  '/puglia/comuni/martano/': '/comuni/martano/',
  '/puglia/comuni/martano/index.html': '/comuni/martano/',
  '/puglia/comuni/martignano.html': '/comuni/martignano/',
  '/puglia/comuni/martignano/': '/comuni/martignano/',
  '/puglia/comuni/martignano/index.html': '/comuni/martignano/',
  '/puglia/comuni/martina_franca.html': '/comuni/martina_franca/',
  '/puglia/comuni/martina_franca/': '/comuni/martina_franca/',
  '/puglia/comuni/martina_franca/index.html': '/comuni/martina_franca/',
  '/puglia/comuni/maruggio.html': '/comuni/maruggio/',
  '/puglia/comuni/maruggio/': '/comuni/maruggio/',
  '/puglia/comuni/maruggio/index.html': '/comuni/maruggio/',
  '/puglia/comuni/massafra.html': '/comuni/massafra/',
  '/puglia/comuni/massafra/': '/comuni/massafra/',
  '/puglia/comuni/massafra/index.html': '/comuni/massafra/',
  '/puglia/comuni/matino.html': '/comuni/matino/',
  '/puglia/comuni/matino/': '/comuni/matino/',
  '/puglia/comuni/matino/index.html': '/comuni/matino/',
  '/puglia/comuni/mattinata.html': '/comuni/mattinata/',
  '/puglia/comuni/mattinata/': '/comuni/mattinata/',
  '/puglia/comuni/mattinata/index.html': '/comuni/mattinata/',
  '/puglia/comuni/melendugno.html': '/comuni/melendugno/',
  '/puglia/comuni/melendugno/': '/comuni/melendugno/',
  '/puglia/comuni/melendugno/index.html': '/comuni/melendugno/',
  '/puglia/comuni/melissano.html': '/comuni/melissano/',
  '/puglia/comuni/melissano/': '/comuni/melissano/',
  '/puglia/comuni/melissano/index.html': '/comuni/melissano/',
  '/puglia/comuni/melpignano.html': '/comuni/melpignano/',
  '/puglia/comuni/melpignano/': '/comuni/melpignano/',
  '/puglia/comuni/melpignano/index.html': '/comuni/melpignano/',
  '/puglia/comuni/mesagne.html': '/comuni/mesagne/',
  '/puglia/comuni/mesagne/': '/comuni/mesagne/',
  '/puglia/comuni/mesagne/index.html': '/comuni/mesagne/',
  '/puglia/comuni/miggiano.html': '/comuni/miggiano/',
  '/puglia/comuni/miggiano/': '/comuni/miggiano/',
  '/puglia/comuni/miggiano/index.html': '/comuni/miggiano/',
  '/puglia/comuni/minervino_di_lecce.html': '/comuni/minervino_di_lecce/',
  '/puglia/comuni/minervino_di_lecce/': '/comuni/minervino_di_lecce/',
  '/puglia/comuni/minervino_di_lecce/index.html': '/comuni/minervino_di_lecce/',
  '/puglia/comuni/minervino_murge.html': '/comuni/minervino_murge/',
  '/puglia/comuni/minervino_murge/': '/comuni/minervino_murge/',
  '/puglia/comuni/minervino_murge/index.html': '/comuni/minervino_murge/',
  '/puglia/comuni/modugno.html': '/comuni/modugno/',
  '/puglia/comuni/modugno/': '/comuni/modugno/',
  '/puglia/comuni/modugno/index.html': '/comuni/modugno/',
  '/puglia/comuni/mola_di_bari.html': '/comuni/mola_di_bari/',
  '/puglia/comuni/mola_di_bari/': '/comuni/mola_di_bari/',
  '/puglia/comuni/mola_di_bari/index.html': '/comuni/mola_di_bari/',
  '/puglia/comuni/molfetta.html': '/comuni/molfetta/',
  '/puglia/comuni/molfetta/': '/comuni/molfetta/',
  '/puglia/comuni/molfetta/index.html': '/comuni/molfetta/',
  '/puglia/comuni/monopoli.html': '/comuni/monopoli/',
  '/puglia/comuni/monopoli/': '/comuni/monopoli/',
  '/puglia/comuni/monopoli/index.html': '/comuni/monopoli/',
  '/puglia/comuni/monte_santangelo.html': '/comuni/monte_santangelo/',
  '/puglia/comuni/monte_santangelo/': '/comuni/monte_santangelo/',
  '/puglia/comuni/monte_santangelo/index.html': '/comuni/monte_santangelo/',
  '/puglia/comuni/monteiasi.html': '/comuni/monteiasi/',
  '/puglia/comuni/monteiasi/': '/comuni/monteiasi/',
  '/puglia/comuni/monteiasi/index.html': '/comuni/monteiasi/',
  '/puglia/comuni/monteleone_di_puglia.html': '/comuni/monteleone_di_puglia/',
  '/puglia/comuni/monteleone_di_puglia/': '/comuni/monteleone_di_puglia/',
  '/puglia/comuni/monteleone_di_puglia/index.html': '/comuni/monteleone_di_puglia/',
  '/puglia/comuni/montemesola.html': '/comuni/montemesola/',
  '/puglia/comuni/montemesola/': '/comuni/montemesola/',
  '/puglia/comuni/montemesola/index.html': '/comuni/montemesola/',
  '/puglia/comuni/monteparano.html': '/comuni/monteparano/',
  '/puglia/comuni/monteparano/': '/comuni/monteparano/',
  '/puglia/comuni/monteparano/index.html': '/comuni/monteparano/',
  '/puglia/comuni/monteroni_di_lecce.html': '/comuni/monteroni_di_lecce/',
  '/puglia/comuni/monteroni_di_lecce/': '/comuni/monteroni_di_lecce/',
  '/puglia/comuni/monteroni_di_lecce/index.html': '/comuni/monteroni_di_lecce/',
  '/puglia/comuni/montesano_salentino.html': '/comuni/montesano_salentino/',
  '/puglia/comuni/montesano_salentino/': '/comuni/montesano_salentino/',
  '/puglia/comuni/montesano_salentino/index.html': '/comuni/montesano_salentino/',
  '/puglia/comuni/morciano_di_leuca.html': '/comuni/morciano_di_leuca/',
  '/puglia/comuni/morciano_di_leuca/': '/comuni/morciano_di_leuca/',
  '/puglia/comuni/morciano_di_leuca/index.html': '/comuni/morciano_di_leuca/',
  '/puglia/comuni/motta_montecorvino.html': '/comuni/motta_montecorvino/',
  '/puglia/comuni/motta_montecorvino/': '/comuni/motta_montecorvino/',
  '/puglia/comuni/motta_montecorvino/index.html': '/comuni/motta_montecorvino/',
  '/puglia/comuni/mottola.html': '/comuni/mottola/',
  '/puglia/comuni/mottola/': '/comuni/mottola/',
  '/puglia/comuni/mottola/index.html': '/comuni/mottola/',
  '/puglia/comuni/muro_leccese.html': '/comuni/muro_leccese/',
  '/puglia/comuni/muro_leccese/': '/comuni/muro_leccese/',
  '/puglia/comuni/muro_leccese/index.html': '/comuni/muro_leccese/',
  '/puglia/comuni/nardo.html': '/comuni/nardo/',
  '/puglia/comuni/nardo/': '/comuni/nardo/',
  '/puglia/comuni/nardo/index.html': '/comuni/nardo/',
  '/puglia/comuni/neviano.html': '/comuni/neviano/',
  '/puglia/comuni/neviano/': '/comuni/neviano/',
  '/puglia/comuni/neviano/index.html': '/comuni/neviano/',
  '/puglia/comuni/noci.html': '/comuni/noci/',
  '/puglia/comuni/noci/': '/comuni/noci/',
  '/puglia/comuni/noci/index.html': '/comuni/noci/',
  '/puglia/comuni/nociglia.html': '/comuni/nociglia/',
  '/puglia/comuni/nociglia/': '/comuni/nociglia/',
  '/puglia/comuni/nociglia/index.html': '/comuni/nociglia/',
  '/puglia/comuni/noicattaro.html': '/comuni/noicattaro/',
  '/puglia/comuni/noicattaro/': '/comuni/noicattaro/',
  '/puglia/comuni/noicattaro/index.html': '/comuni/noicattaro/',
  '/puglia/comuni/novoli.html': '/comuni/novoli/',
  '/puglia/comuni/novoli/': '/comuni/novoli/',
  '/puglia/comuni/novoli/index.html': '/comuni/novoli/',
  '/puglia/comuni/ordona.html': '/comuni/ordona/',
  '/puglia/comuni/ordona/': '/comuni/ordona/',
  '/puglia/comuni/ordona/index.html': '/comuni/ordona/',
  '/puglia/comuni/oria.html': '/comuni/oria/',
  '/puglia/comuni/oria/': '/comuni/oria/',
  '/puglia/comuni/oria/index.html': '/comuni/oria/',
  '/puglia/comuni/orsara_di_puglia.html': '/comuni/orsara_di_puglia/',
  '/puglia/comuni/orsara_di_puglia/': '/comuni/orsara_di_puglia/',
  '/puglia/comuni/orsara_di_puglia/index.html': '/comuni/orsara_di_puglia/',
  '/puglia/comuni/orta_nova.html': '/comuni/orta_nova/',
  '/puglia/comuni/orta_nova/': '/comuni/orta_nova/',
  '/puglia/comuni/orta_nova/index.html': '/comuni/orta_nova/',
  '/puglia/comuni/ortelle.html': '/comuni/ortelle/',
  '/puglia/comuni/ortelle/': '/comuni/ortelle/',
  '/puglia/comuni/ortelle/index.html': '/comuni/ortelle/',
  '/puglia/comuni/ostuni.html': '/comuni/ostuni/',
  '/puglia/comuni/ostuni/': '/comuni/ostuni/',
  '/puglia/comuni/ostuni/index.html': '/comuni/ostuni/',
  '/puglia/comuni/otranto.html': '/comuni/otranto/',
  '/puglia/comuni/otranto/': '/comuni/otranto/',
  '/puglia/comuni/otranto/index.html': '/comuni/otranto/',
  '/puglia/comuni/palagianello.html': '/comuni/palagianello/',
  '/puglia/comuni/palagianello/': '/comuni/palagianello/',
  '/puglia/comuni/palagianello/index.html': '/comuni/palagianello/',
  '/puglia/comuni/palagiano.html': '/comuni/palagiano/',
  '/puglia/comuni/palagiano/': '/comuni/palagiano/',
  '/puglia/comuni/palagiano/index.html': '/comuni/palagiano/',
  '/puglia/comuni/palmariggi.html': '/comuni/palmariggi/',
  '/puglia/comuni/palmariggi/': '/comuni/palmariggi/',
  '/puglia/comuni/palmariggi/index.html': '/comuni/palmariggi/',
  '/puglia/comuni/palo_del_colle.html': '/comuni/palo_del_colle/',
  '/puglia/comuni/palo_del_colle/': '/comuni/palo_del_colle/',
  '/puglia/comuni/palo_del_colle/index.html': '/comuni/palo_del_colle/',
  '/puglia/comuni/panni.html': '/comuni/panni/',
  '/puglia/comuni/panni/': '/comuni/panni/',
  '/puglia/comuni/panni/index.html': '/comuni/panni/',
  '/puglia/comuni/parabita.html': '/comuni/parabita/',
  '/puglia/comuni/parabita/': '/comuni/parabita/',
  '/puglia/comuni/parabita/index.html': '/comuni/parabita/',
  '/puglia/comuni/patu.html': '/comuni/patu/',
  '/puglia/comuni/patu/': '/comuni/patu/',
  '/puglia/comuni/patu/index.html': '/comuni/patu/',
  '/puglia/comuni/peschici.html': '/comuni/peschici/',
  '/puglia/comuni/peschici/': '/comuni/peschici/',
  '/puglia/comuni/peschici/index.html': '/comuni/peschici/',
  '/puglia/comuni/pietramontecorvino.html': '/comuni/pietramontecorvino/',
  '/puglia/comuni/pietramontecorvino/': '/comuni/pietramontecorvino/',
  '/puglia/comuni/pietramontecorvino/index.html': '/comuni/pietramontecorvino/',
  '/puglia/comuni/poggiardo.html': '/comuni/poggiardo/',
  '/puglia/comuni/poggiardo/': '/comuni/poggiardo/',
  '/puglia/comuni/poggiardo/index.html': '/comuni/poggiardo/',
  '/puglia/comuni/poggio_imperiale.html': '/comuni/poggio_imperiale/',
  '/puglia/comuni/poggio_imperiale/': '/comuni/poggio_imperiale/',
  '/puglia/comuni/poggio_imperiale/index.html': '/comuni/poggio_imperiale/',
  '/puglia/comuni/poggiorsini.html': '/comuni/poggiorsini/',
  '/puglia/comuni/poggiorsini/': '/comuni/poggiorsini/',
  '/puglia/comuni/poggiorsini/index.html': '/comuni/poggiorsini/',
  '/puglia/comuni/polignano_a_mare.html': '/comuni/polignano_a_mare/',
  '/puglia/comuni/polignano_a_mare/': '/comuni/polignano_a_mare/',
  '/puglia/comuni/polignano_a_mare/index.html': '/comuni/polignano_a_mare/',
  '/puglia/comuni/porto_cesareo.html': '/comuni/porto_cesareo/',
  '/puglia/comuni/porto_cesareo/': '/comuni/porto_cesareo/',
  '/puglia/comuni/porto_cesareo/index.html': '/comuni/porto_cesareo/',
  '/puglia/comuni/presicce-acquarica.html': '/comuni/presicce-acquarica/',
  '/puglia/comuni/presicce-acquarica/': '/comuni/presicce-acquarica/',
  '/puglia/comuni/presicce-acquarica/index.html': '/comuni/presicce-acquarica/',
  '/puglia/comuni/pulsano.html': '/comuni/pulsano/',
  '/puglia/comuni/pulsano/': '/comuni/pulsano/',
  '/puglia/comuni/pulsano/index.html': '/comuni/pulsano/',
  '/puglia/comuni/putignano.html': '/comuni/putignano/',
  '/puglia/comuni/putignano/': '/comuni/putignano/',
  '/puglia/comuni/putignano/index.html': '/comuni/putignano/',
  '/puglia/comuni/racale.html': '/comuni/racale/',
  '/puglia/comuni/racale/': '/comuni/racale/',
  '/puglia/comuni/racale/index.html': '/comuni/racale/',
  '/puglia/comuni/rignano_garganico.html': '/comuni/rignano_garganico/',
  '/puglia/comuni/rignano_garganico/': '/comuni/rignano_garganico/',
  '/puglia/comuni/rignano_garganico/index.html': '/comuni/rignano_garganico/',
  '/puglia/comuni/roccaforzata.html': '/comuni/roccaforzata/',
  '/puglia/comuni/roccaforzata/': '/comuni/roccaforzata/',
  '/puglia/comuni/roccaforzata/index.html': '/comuni/roccaforzata/',
  '/puglia/comuni/rocchetta_santantonio.html': '/comuni/rocchetta_santantonio/',
  '/puglia/comuni/rocchetta_santantonio/': '/comuni/rocchetta_santantonio/',
  '/puglia/comuni/rocchetta_santantonio/index.html': '/comuni/rocchetta_santantonio/',
  '/puglia/comuni/rodi_garganico.html': '/comuni/rodi_garganico/',
  '/puglia/comuni/rodi_garganico/': '/comuni/rodi_garganico/',
  '/puglia/comuni/rodi_garganico/index.html': '/comuni/rodi_garganico/',
  '/puglia/comuni/roseto_valfortore.html': '/comuni/roseto_valfortore/',
  '/puglia/comuni/roseto_valfortore/': '/comuni/roseto_valfortore/',
  '/puglia/comuni/roseto_valfortore/index.html': '/comuni/roseto_valfortore/',
  '/puglia/comuni/ruffano.html': '/comuni/ruffano/',
  '/puglia/comuni/ruffano/': '/comuni/ruffano/',
  '/puglia/comuni/ruffano/index.html': '/comuni/ruffano/',
  '/puglia/comuni/rutigliano.html': '/comuni/rutigliano/',
  '/puglia/comuni/rutigliano/': '/comuni/rutigliano/',
  '/puglia/comuni/rutigliano/index.html': '/comuni/rutigliano/',
  '/puglia/comuni/ruvo_di_puglia.html': '/comuni/ruvo_di_puglia/',
  '/puglia/comuni/ruvo_di_puglia/': '/comuni/ruvo_di_puglia/',
  '/puglia/comuni/ruvo_di_puglia/index.html': '/comuni/ruvo_di_puglia/',
  '/puglia/comuni/salice_salentino.html': '/comuni/salice_salentino/',
  '/puglia/comuni/salice_salentino/': '/comuni/salice_salentino/',
  '/puglia/comuni/salice_salentino/index.html': '/comuni/salice_salentino/',
  '/puglia/comuni/salve.html': '/comuni/salve/',
  '/puglia/comuni/salve/': '/comuni/salve/',
  '/puglia/comuni/salve/index.html': '/comuni/salve/',
  '/puglia/comuni/sammichele_di_bari.html': '/comuni/sammichele_di_bari/',
  '/puglia/comuni/sammichele_di_bari/': '/comuni/sammichele_di_bari/',
  '/puglia/comuni/sammichele_di_bari/index.html': '/comuni/sammichele_di_bari/',
  '/puglia/comuni/san_cassiano.html': '/comuni/san_cassiano/',
  '/puglia/comuni/san_cassiano/': '/comuni/san_cassiano/',
  '/puglia/comuni/san_cassiano/index.html': '/comuni/san_cassiano/',
  '/puglia/comuni/san_cesario_di_lecce.html': '/comuni/san_cesario_di_lecce/',
  '/puglia/comuni/san_cesario_di_lecce/': '/comuni/san_cesario_di_lecce/',
  '/puglia/comuni/san_cesario_di_lecce/index.html': '/comuni/san_cesario_di_lecce/',
  '/puglia/comuni/san_donaci.html': '/comuni/san_donaci/',
  '/puglia/comuni/san_donaci/': '/comuni/san_donaci/',
  '/puglia/comuni/san_donaci/index.html': '/comuni/san_donaci/',
  '/puglia/comuni/san_donato_di_lecce.html': '/comuni/san_donato_di_lecce/',
  '/puglia/comuni/san_donato_di_lecce/': '/comuni/san_donato_di_lecce/',
  '/puglia/comuni/san_donato_di_lecce/index.html': '/comuni/san_donato_di_lecce/',
  '/puglia/comuni/san_ferdinando_di_puglia.html': '/comuni/san_ferdinando_di_puglia/',
  '/puglia/comuni/san_ferdinando_di_puglia/': '/comuni/san_ferdinando_di_puglia/',
  '/puglia/comuni/san_ferdinando_di_puglia/index.html': '/comuni/san_ferdinando_di_puglia/',
  '/puglia/comuni/san_giorgio_ionico.html': '/comuni/san_giorgio_ionico/',
  '/puglia/comuni/san_giorgio_ionico/': '/comuni/san_giorgio_ionico/',
  '/puglia/comuni/san_giorgio_ionico/index.html': '/comuni/san_giorgio_ionico/',
  '/puglia/comuni/san_giovanni_rotondo.html': '/comuni/san_giovanni_rotondo/',
  '/puglia/comuni/san_giovanni_rotondo/': '/comuni/san_giovanni_rotondo/',
  '/puglia/comuni/san_giovanni_rotondo/index.html': '/comuni/san_giovanni_rotondo/',
  '/puglia/comuni/san_marco_in_lamis.html': '/comuni/san_marco_in_lamis/',
  '/puglia/comuni/san_marco_in_lamis/': '/comuni/san_marco_in_lamis/',
  '/puglia/comuni/san_marco_in_lamis/index.html': '/comuni/san_marco_in_lamis/',
  '/puglia/comuni/san_marco_la_catola.html': '/comuni/san_marco_la_catola/',
  '/puglia/comuni/san_marco_la_catola/': '/comuni/san_marco_la_catola/',
  '/puglia/comuni/san_marco_la_catola/index.html': '/comuni/san_marco_la_catola/',
  '/puglia/comuni/san_marzano_di_san_giuseppe.html': '/comuni/san_marzano_di_san_giuseppe/',
  '/puglia/comuni/san_marzano_di_san_giuseppe/': '/comuni/san_marzano_di_san_giuseppe/',
  '/puglia/comuni/san_marzano_di_san_giuseppe/index.html': '/comuni/san_marzano_di_san_giuseppe/',
  '/puglia/comuni/san_michele_salentino.html': '/comuni/san_michele_salentino/',
  '/puglia/comuni/san_michele_salentino/': '/comuni/san_michele_salentino/',
  '/puglia/comuni/san_michele_salentino/index.html': '/comuni/san_michele_salentino/',
  '/puglia/comuni/san_nicandro_garganico.html': '/comuni/san_nicandro_garganico/',
  '/puglia/comuni/san_nicandro_garganico/': '/comuni/san_nicandro_garganico/',
  '/puglia/comuni/san_nicandro_garganico/index.html': '/comuni/san_nicandro_garganico/',
  '/puglia/comuni/san_pancrazio_salentino.html': '/comuni/san_pancrazio_salentino/',
  '/puglia/comuni/san_pancrazio_salentino/': '/comuni/san_pancrazio_salentino/',
  '/puglia/comuni/san_pancrazio_salentino/index.html': '/comuni/san_pancrazio_salentino/',
  '/puglia/comuni/san_paolo_di_civitate.html': '/comuni/san_paolo_di_civitate/',
  '/puglia/comuni/san_paolo_di_civitate/': '/comuni/san_paolo_di_civitate/',
  '/puglia/comuni/san_paolo_di_civitate/index.html': '/comuni/san_paolo_di_civitate/',
  '/puglia/comuni/san_pietro_in_lama.html': '/comuni/san_pietro_in_lama/',
  '/puglia/comuni/san_pietro_in_lama/': '/comuni/san_pietro_in_lama/',
  '/puglia/comuni/san_pietro_in_lama/index.html': '/comuni/san_pietro_in_lama/',
  '/puglia/comuni/san_pietro_vernotico.html': '/comuni/san_pietro_vernotico/',
  '/puglia/comuni/san_pietro_vernotico/': '/comuni/san_pietro_vernotico/',
  '/puglia/comuni/san_pietro_vernotico/index.html': '/comuni/san_pietro_vernotico/',
  '/puglia/comuni/san_severo.html': '/comuni/san_severo/',
  '/puglia/comuni/san_severo/': '/comuni/san_severo/',
  '/puglia/comuni/san_severo/index.html': '/comuni/san_severo/',
  '/puglia/comuni/san_vito_dei_normanni.html': '/comuni/san_vito_dei_normanni/',
  '/puglia/comuni/san_vito_dei_normanni/': '/comuni/san_vito_dei_normanni/',
  '/puglia/comuni/san_vito_dei_normanni/index.html': '/comuni/san_vito_dei_normanni/',
  '/puglia/comuni/sanarica.html': '/comuni/sanarica/',
  '/puglia/comuni/sanarica/': '/comuni/sanarica/',
  '/puglia/comuni/sanarica/index.html': '/comuni/sanarica/',
  '/puglia/comuni/sannicandro_di_bari.html': '/comuni/sannicandro_di_bari/',
  '/puglia/comuni/sannicandro_di_bari/': '/comuni/sannicandro_di_bari/',
  '/puglia/comuni/sannicandro_di_bari/index.html': '/comuni/sannicandro_di_bari/',
  '/puglia/comuni/sannicola.html': '/comuni/sannicola/',
  '/puglia/comuni/sannicola/': '/comuni/sannicola/',
  '/puglia/comuni/sannicola/index.html': '/comuni/sannicola/',
  '/puglia/comuni/santa_cesarea_terme.html': '/comuni/santa_cesarea_terme/',
  '/puglia/comuni/santa_cesarea_terme/': '/comuni/santa_cesarea_terme/',
  '/puglia/comuni/santa_cesarea_terme/index.html': '/comuni/santa_cesarea_terme/',
  '/puglia/comuni/santagata_di_puglia.html': '/comuni/santagata_di_puglia/',
  '/puglia/comuni/santagata_di_puglia/': '/comuni/santagata_di_puglia/',
  '/puglia/comuni/santagata_di_puglia/index.html': '/comuni/santagata_di_puglia/',
  '/puglia/comuni/santeramo_in_colle.html': '/comuni/santeramo_in_colle/',
  '/puglia/comuni/santeramo_in_colle/': '/comuni/santeramo_in_colle/',
  '/puglia/comuni/santeramo_in_colle/index.html': '/comuni/santeramo_in_colle/',
  '/puglia/comuni/sava.html': '/comuni/sava/',
  '/puglia/comuni/sava/': '/comuni/sava/',
  '/puglia/comuni/sava/index.html': '/comuni/sava/',
  '/puglia/comuni/scorrano.html': '/comuni/scorrano/',
  '/puglia/comuni/scorrano/': '/comuni/scorrano/',
  '/puglia/comuni/scorrano/index.html': '/comuni/scorrano/',
  '/puglia/comuni/secli.html': '/comuni/secli/',
  '/puglia/comuni/secli/': '/comuni/secli/',
  '/puglia/comuni/secli/index.html': '/comuni/secli/',
  '/puglia/comuni/serracapriola.html': '/comuni/serracapriola/',
  '/puglia/comuni/serracapriola/': '/comuni/serracapriola/',
  '/puglia/comuni/serracapriola/index.html': '/comuni/serracapriola/',
  '/puglia/comuni/sogliano_cavour.html': '/comuni/sogliano_cavour/',
  '/puglia/comuni/sogliano_cavour/': '/comuni/sogliano_cavour/',
  '/puglia/comuni/sogliano_cavour/index.html': '/comuni/sogliano_cavour/',
  '/puglia/comuni/soleto.html': '/comuni/soleto/',
  '/puglia/comuni/soleto/': '/comuni/soleto/',
  '/puglia/comuni/soleto/index.html': '/comuni/soleto/',
  '/puglia/comuni/specchia.html': '/comuni/specchia/',
  '/puglia/comuni/specchia/': '/comuni/specchia/',
  '/puglia/comuni/specchia/index.html': '/comuni/specchia/',
  '/puglia/comuni/spinazzola.html': '/comuni/spinazzola/',
  '/puglia/comuni/spinazzola/': '/comuni/spinazzola/',
  '/puglia/comuni/spinazzola/index.html': '/comuni/spinazzola/',
  '/puglia/comuni/spongano.html': '/comuni/spongano/',
  '/puglia/comuni/spongano/': '/comuni/spongano/',
  '/puglia/comuni/spongano/index.html': '/comuni/spongano/',
  '/puglia/comuni/squinzano.html': '/comuni/squinzano/',
  '/puglia/comuni/squinzano/': '/comuni/squinzano/',
  '/puglia/comuni/squinzano/index.html': '/comuni/squinzano/',
  '/puglia/comuni/statte.html': '/comuni/statte/',
  '/puglia/comuni/statte/': '/comuni/statte/',
  '/puglia/comuni/statte/index.html': '/comuni/statte/',
  '/puglia/comuni/sternatia.html': '/comuni/sternatia/',
  '/puglia/comuni/sternatia/': '/comuni/sternatia/',
  '/puglia/comuni/sternatia/index.html': '/comuni/sternatia/',
  '/puglia/comuni/stornara.html': '/comuni/stornara/',
  '/puglia/comuni/stornara/': '/comuni/stornara/',
  '/puglia/comuni/stornara/index.html': '/comuni/stornara/',
  '/puglia/comuni/stornarella.html': '/comuni/stornarella/',
  '/puglia/comuni/stornarella/': '/comuni/stornarella/',
  '/puglia/comuni/stornarella/index.html': '/comuni/stornarella/',
  '/puglia/comuni/supersano.html': '/comuni/supersano/',
  '/puglia/comuni/supersano/': '/comuni/supersano/',
  '/puglia/comuni/supersano/index.html': '/comuni/supersano/',
  '/puglia/comuni/surano.html': '/comuni/surano/',
  '/puglia/comuni/surano/': '/comuni/surano/',
  '/puglia/comuni/surano/index.html': '/comuni/surano/',
  '/puglia/comuni/surbo.html': '/comuni/surbo/',
  '/puglia/comuni/surbo/': '/comuni/surbo/',
  '/puglia/comuni/surbo/index.html': '/comuni/surbo/',
  '/puglia/comuni/taranto.html': '/comuni/taranto/',
  '/puglia/comuni/taranto/': '/comuni/taranto/',
  '/puglia/comuni/taranto/index.html': '/comuni/taranto/',
  '/puglia/comuni/taurisano.html': '/comuni/taurisano/',
  '/puglia/comuni/taurisano/': '/comuni/taurisano/',
  '/puglia/comuni/taurisano/index.html': '/comuni/taurisano/',
  '/puglia/comuni/taviano.html': '/comuni/taviano/',
  '/puglia/comuni/taviano/': '/comuni/taviano/',
  '/puglia/comuni/taviano/index.html': '/comuni/taviano/',
  '/puglia/comuni/terlizzi.html': '/comuni/terlizzi/',
  '/puglia/comuni/terlizzi/': '/comuni/terlizzi/',
  '/puglia/comuni/terlizzi/index.html': '/comuni/terlizzi/',
  '/puglia/comuni/tiggiano.html': '/comuni/tiggiano/',
  '/puglia/comuni/tiggiano/': '/comuni/tiggiano/',
  '/puglia/comuni/tiggiano/index.html': '/comuni/tiggiano/',
  '/puglia/comuni/torchiarolo.html': '/comuni/torchiarolo/',
  '/puglia/comuni/torchiarolo/': '/comuni/torchiarolo/',
  '/puglia/comuni/torchiarolo/index.html': '/comuni/torchiarolo/',
  '/puglia/comuni/toritto.html': '/comuni/toritto/',
  '/puglia/comuni/toritto/': '/comuni/toritto/',
  '/puglia/comuni/toritto/index.html': '/comuni/toritto/',
  '/puglia/comuni/torre_santa_susanna.html': '/comuni/torre_santa_susanna/',
  '/puglia/comuni/torre_santa_susanna/': '/comuni/torre_santa_susanna/',
  '/puglia/comuni/torre_santa_susanna/index.html': '/comuni/torre_santa_susanna/',
  '/puglia/comuni/torremaggiore.html': '/comuni/torremaggiore/',
  '/puglia/comuni/torremaggiore/': '/comuni/torremaggiore/',
  '/puglia/comuni/torremaggiore/index.html': '/comuni/torremaggiore/',
  '/puglia/comuni/torricella.html': '/comuni/torricella/',
  '/puglia/comuni/torricella/': '/comuni/torricella/',
  '/puglia/comuni/torricella/index.html': '/comuni/torricella/',
  '/puglia/comuni/trani.html': '/comuni/trani/',
  '/puglia/comuni/trani/': '/comuni/trani/',
  '/puglia/comuni/trani/index.html': '/comuni/trani/',
  '/puglia/comuni/trepuzzi.html': '/comuni/trepuzzi/',
  '/puglia/comuni/trepuzzi/': '/comuni/trepuzzi/',
  '/puglia/comuni/trepuzzi/index.html': '/comuni/trepuzzi/',
  '/puglia/comuni/tricase.html': '/comuni/tricase/',
  '/puglia/comuni/tricase/': '/comuni/tricase/',
  '/puglia/comuni/tricase/index.html': '/comuni/tricase/',
  '/puglia/comuni/triggiano.html': '/comuni/triggiano/',
  '/puglia/comuni/triggiano/': '/comuni/triggiano/',
  '/puglia/comuni/triggiano/index.html': '/comuni/triggiano/',
  '/puglia/comuni/trinitapoli.html': '/comuni/trinitapoli/',
  '/puglia/comuni/trinitapoli/': '/comuni/trinitapoli/',
  '/puglia/comuni/trinitapoli/index.html': '/comuni/trinitapoli/',
  '/puglia/comuni/troia.html': '/comuni/troia/',
  '/puglia/comuni/troia/': '/comuni/troia/',
  '/puglia/comuni/troia/index.html': '/comuni/troia/',
  '/puglia/comuni/tuglie.html': '/comuni/tuglie/',
  '/puglia/comuni/tuglie/': '/comuni/tuglie/',
  '/puglia/comuni/tuglie/index.html': '/comuni/tuglie/',
  '/puglia/comuni/turi.html': '/comuni/turi/',
  '/puglia/comuni/turi/': '/comuni/turi/',
  '/puglia/comuni/turi/index.html': '/comuni/turi/',
  '/puglia/comuni/ugento.html': '/comuni/ugento/',
  '/puglia/comuni/ugento/': '/comuni/ugento/',
  '/puglia/comuni/ugento/index.html': '/comuni/ugento/',
  '/puglia/comuni/uggiano_la_chiesa.html': '/comuni/uggiano_la_chiesa/',
  '/puglia/comuni/uggiano_la_chiesa/': '/comuni/uggiano_la_chiesa/',
  '/puglia/comuni/uggiano_la_chiesa/index.html': '/comuni/uggiano_la_chiesa/',
  '/puglia/comuni/valenzano.html': '/comuni/valenzano/',
  '/puglia/comuni/valenzano/': '/comuni/valenzano/',
  '/puglia/comuni/valenzano/index.html': '/comuni/valenzano/',
  '/puglia/comuni/veglie.html': '/comuni/veglie/',
  '/puglia/comuni/veglie/': '/comuni/veglie/',
  '/puglia/comuni/veglie/index.html': '/comuni/veglie/',
  '/puglia/comuni/vernole.html': '/comuni/vernole/',
  '/puglia/comuni/vernole/': '/comuni/vernole/',
  '/puglia/comuni/vernole/index.html': '/comuni/vernole/',
  '/puglia/comuni/vico_del_gargano.html': '/comuni/vico_del_gargano/',
  '/puglia/comuni/vico_del_gargano/': '/comuni/vico_del_gargano/',
  '/puglia/comuni/vico_del_gargano/index.html': '/comuni/vico_del_gargano/',
  '/puglia/comuni/vieste.html': '/comuni/vieste/',
  '/puglia/comuni/vieste/': '/comuni/vieste/',
  '/puglia/comuni/vieste/index.html': '/comuni/vieste/',
  '/puglia/comuni/villa_castelli.html': '/comuni/villa_castelli/',
  '/puglia/comuni/villa_castelli/': '/comuni/villa_castelli/',
  '/puglia/comuni/villa_castelli/index.html': '/comuni/villa_castelli/',
  '/puglia/comuni/volturara_appula.html': '/comuni/volturara_appula/',
  '/puglia/comuni/volturara_appula/': '/comuni/volturara_appula/',
  '/puglia/comuni/volturara_appula/index.html': '/comuni/volturara_appula/',
  '/puglia/comuni/volturino.html': '/comuni/volturino/',
  '/puglia/comuni/volturino/': '/comuni/volturino/',
  '/puglia/comuni/volturino/index.html': '/comuni/volturino/',
  '/puglia/comuni/zapponeta.html': '/comuni/zapponeta/',
  '/puglia/comuni/zapponeta/': '/comuni/zapponeta/',
  '/puglia/comuni/zapponeta/index.html': '/comuni/zapponeta/',
  '/puglia/eventi/aggiungi-evento.html': '/eventi/proponi/',
  '/puglia/eventi/candida-evento.html': '/eventi/proponi/',
  '/puglia/eventi/eventi-live.html': '/eventi/live/',
  '/puglia/eventi/eventi.html': '/eventi/',
  '/puglia/eventi/proponi-evento.html': '/eventi/proponi/',
  '/puglia/eventi/social-kit-evento.html': '/eventi/social-kit/',
  '/puglia/index.html': '/',
  '/puglia/kh/': '/kiosk/',
  '/puglia/kh/index.html': '/kiosk/',
  '/puglia/kiosk/': '/kiosk/',
  '/puglia/kiosk/index.html': '/kiosk/',
  '/puglia/kiosk/launcher.html': '/kiosk/',
  '/puglia/kv/': '/kiosk/',
  '/puglia/kv/index.html': '/kiosk/',
  '/puglia/lavoro-servizi/': '/rete-civica/jobcoin/',
  '/puglia/legale/accessibilita.html': '/accessibilita/',
  '/puglia/legale/cookie-policy.html': '/legale/cookie/',
  '/puglia/legale/dichiarazione-accessibilita.html': '/legale/accessibilita/',
  '/puglia/legale/privacy-policy.html': '/legale/privacy/',
  '/puglia/m/': '/',
  '/puglia/m/index.html': '/',
  '/puglia/mappa-multimediale/': '/territorio/mappa-multimediale/',
  '/puglia/mappa-multimediale/index.html': '/territorio/mappa-multimediale/',
  '/puglia/news/': '/news/',
  '/puglia/news/index.html': '/news/',
  '/puglia/opportunita/': '/opportunita/',
  '/puglia/opportunita/index.html': '/opportunita/',
  '/puglia/progetto/dati-aperti.html': '/progetto/dati-aperti/',
  '/puglia/progetto/fonti-dati.html': '/progetto/fonti-dati/',
  '/puglia/progetto/mission.html': '/progetto/',
  '/puglia/progetto/progetto-pilota.html': '/progetto/pilota/',
  '/puglia/progetto/status.html': '/progetto/status/',
  '/puglia/province/bari.html': '/province/bari/',
  '/puglia/province/bat.html': '/province/bat/',
  '/puglia/province/brindisi.html': '/province/brindisi/',
  '/puglia/province/foggia.html': '/province/foggia/',
  '/puglia/province/lecce.html': '/province/lecce/',
  '/puglia/province/taranto.html': '/province/taranto/',
  '/puglia/rete-civica/attiva-comune.html': '/rete-civica/attiva-comune/',
  '/puglia/rete-civica/cittadinanza-attiva.html': '/rete-civica/cittadinanza-attiva/',
  '/puglia/rete-civica/civic-network.html': '/rete-civica/',
  '/puglia/rete-civica/jobcoin-wizard.html': '/rete-civica/jobcoin/',
  '/puglia/rete-civica/partecipa.html': '/rete-civica/partecipa/',
  '/puglia/scegli/': '/',
  '/puglia/scegli/index.html': '/',
  '/puglia/scopri-puglia.html': '/territorio/scopri/',
  '/puglia/servizi/istruzione.html': '/servizi/istruzione/',
  '/puglia/servizi/meteo.html': '/servizi/meteo/',
  '/puglia/servizi/servizi.html': '/servizi/',
  '/puglia/servizi/urp-digitale.html': '/servizi/urp-digitale/',
  '/puglia/territorio/esplora.html': '/territorio/esplora/',
  '/puglia/territorio/gusta-la-puglia.html': '/territorio/gusta/',
  '/puglia/territorio/mare-e-lidi.html': '/territorio/mare-e-lidi/',
  '/puglia/territorio/province.html': '/province/',
  '/puglia/territorio/scopri-la-puglia.html': '/territorio/scopri/',
  '/puglia/territorio/turismo.html': '/territorio/turismo/',
};

/**
 * Regole a pattern, applicate se la corrispondenza esatta non c'è.
 * Coprono i casi che la mappa statica non può enumerare (slug nuovi
 * aggiunti al backend dopo la generazione).
 */
export const LEGACY_PATTERNS: ReadonlyArray<{ test: RegExp; to: (m: RegExpMatchArray) => string }> = [
  { test: /^\/puglia\/comuni\/([a-z0-9_]+)(?:\.html|\/(?:index\.html)?)?$/, to: (m) => `/comuni/${m[1]}/` },
  { test: /^\/comuni\/([a-z0-9_]+)\.html$/, to: (m) => `/comuni/${m[1]}/` },
  { test: /^\/puglia\/cammini\/itinerario-([a-z0-9-]+)\.html$/, to: (m) => `/itinerari/${m[1]}/` },
  { test: /^\/puglia\/province\/([a-z]+)\.html$/, to: (m) => `/province/${m[1]}/` },
  // Qualunque altro percorso sotto /puglia/ finisce sulla home: il
  // prefisso non esiste più (decisione 18).
  { test: /^\/puglia(?:\/.*)?$/, to: () => '/' },
];

/** Risolve un percorso legacy nella nuova rotta, o null se non è legacy. */
export function resolveLegacyPath(pathname: string): string | null {
  const exactHit = LEGACY_REDIRECTS[pathname];
  if (exactHit) return exactHit;
  for (const rule of LEGACY_PATTERNS) {
    const m = pathname.match(rule.test);
    if (m) return rule.to(m);
  }
  return null;
}
